import DOMPurify from "dompurify";

/**
 * Every path that writes HTML into the document goes through here.
 *
 * Chapter content is not authored HTML: it arrives from a model's output, from
 * an imported DOCX, or from a paste. Any of those can carry markup, and the
 * editor writes it with innerHTML into a page that holds the session token.
 *
 * The allow-list is the formatting the editor itself can produce — nothing
 * that loads or executes anything.
 */
const ALLOWED_TAGS = [
  "p", "br", "div", "span", "b", "strong", "i", "em", "u", "s", "mark", "sub", "sup",
  "h1", "h2", "h3", "h4", "ul", "ol", "li", "blockquote", "pre", "code",
  "table", "thead", "tbody", "tr", "th", "td", "hr", "a",
  // Page boundaries carried over from an imported document. Stripping these
  // flattened a paginated file into one continuous block, which is what made
  // the page count disappear.
  "section",
];

const ALLOWED_ATTR = ["class", "style", "data-placeholder", "data-page", "href", "title", "colspan", "rowspan"];

export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input", "link", "meta"],
    FORBID_ATTR: ["srcset", "formaction", "xlink:href"],
  });
}

/** Strip every tag and return the readable text. */
export function htmlToPlainText(html) {
  const div = document.createElement("div");
  div.innerHTML = sanitizeHtml(html);
  return div.innerText;
}

// Any anchor that survives sanitisation must not be able to reach back into
// this tab via window.opener.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.hasAttribute("href")) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});
